module.exports = __webpack_public_path__ + "static/media/Poland_Argentina.c8b70e79.jpeg";